import { render, staticRenderFns } from "./ExternalPanel.vue?vue&type=template&id=e5651010&"
import script from "./ExternalPanel.vue?vue&type=script&lang=js&"
export * from "./ExternalPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports